import { Map } from 'immutable';

import {
  FETCH_FEEDBACK_SUCCESS,
} from './actions';
import Feedback from './model';

export default function feedbackReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_FEEDBACK_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, { payload, sessionId, studentId }) {
  return state.set(`${sessionId}-${studentId}`, Feedback.create(payload));
}



// WEBPACK FOOTER //
// ./data/Feedback/reducer.js